import { useContext } from 'react'
import { Button } from '../Styles'
import "./index.css"
import { ModalEstadoContext } from '../../contexts/ModalEstado';

function ModalOpcoesDesafio() {
  const { modalExibir } = useContext(ModalEstadoContext)

  return (
    <div id='fundoModal'>
      <section className={'containerModalCentro'}>
        <span className='novoContainerTitulo'>
          <h1>Opções do DesaFio</h1>
        </span>

        <section className="formModalNovo">
          <span className='container-option-desafio' onClick={() => { modalExibir("ModalMatrizPriorizacao") }}>
            <label htmlFor="">Matriz Gut</label>
          </span>
          <span className='container-option-desafio' onClick={() => { modalExibir("Modal5w2h") }}>
            <label htmlFor="">5w2h</label>
          </span>
          <span className="botoesContainer">
            <Button type="button" cor="cancelar" isLoading={false} onClick={() => { modalExibir("") }}>
              Cancelar
            </Button>
          </span>
        </section>
      </section>
    </div>
  )
}

export default ModalOpcoesDesafio